export default "__VITE_ASSET__94672057__"